import React from "react";
import clsx from "clsx";

import { CodeSnippet } from "@merge-api/merge-javascript-shared";
import { generateCurl } from "./utils/generateCurl";
import { APIEndpointMethod } from "../../../../models/Entities";
import { LinkedAccountType } from "../enums";
import useLinkedAccountType from "./hooks/useLinkedAccountType";

type CurlCodeBlockProps = {
  className?: string;
  url: string;
  headers?: Record<string, string>;
  body?: string;
  method: APIEndpointMethod;
  mockSandboxAccountToken: string | undefined;
};

const CurlCodeBlock = ({
  className,
  url,
  headers = {},
  body,
  method,
  mockSandboxAccountToken,
}: CurlCodeBlockProps) => {
  // hooks
  const { linkedAccountType } = useLinkedAccountType();

  const curlRequest = generateCurl({
    url,
    headers: {
      Authorization: "Bearer [Insert your API key]",
      "X-Account-Token":
        linkedAccountType === LinkedAccountType.MOCK_SANDBOX && mockSandboxAccountToken
          ? mockSandboxAccountToken
          : "[Insert your account token]",
      ...headers,
    },
    body,
    method,
  });

  return (
    // cURL request embeds the account token and payload and is thus masked at the code block (ph-no-capture for PostHog, data-fr-ignore for the Frigade Assistant DOM snapshot)
    <div className={clsx("ph-no-capture", className)} data-fr-ignore>
      <CodeSnippet
        title="cURL request"
        language="bash"
        variant="gray"
        showCopyButton
        textToCopy={curlRequest}
      >
        {curlRequest}
      </CodeSnippet>
    </div>
  );
};

export default CurlCodeBlock;
